import React, { useEffect, useState } from "react";
import Search from "../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../layout/BreadCrumb";
import CardLoading from "../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../features/fetch/fetchSlice";
import { setActiveObj } from "../../features/obj/objSlice";
import svg38 from "../../assets/svg/svg38.svg";
import useModalToggle from "../../custom_hooks/useModalToggle";
import IrrigationPartnerAddModal from "./modal/IrrigationPartnerAddModal";
import { formatText } from "../../utils";
import { Tooltip } from "antd";

function IrrigationPartnerTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { open, handleCancel, handleOpen } = useModalToggle();

  const handleAdd = () => {
    handleOpen();
  };
  const svgMap = {
    svg38,
  };

  const url = "api/v2/irrPart/getCounts";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        fullName: e.target.value == "" ? null : e.target.value,
        limit: null,
        start: 0,
      })
    );
  };

  const getWords = (text) => text?.split(" ").filter(Boolean);
  const shouldShowTooltip = (text) => getWords(text)?.length > 5;
  const getShortText = (text) => getWords(text)?.slice(0, 5)?.join(" ") + "...";

  const processedData = data?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));
  const handleClick = async (item) => {
    await dispatch(setActiveObj({ key: "partners-category", data: item }));
    await navigate(item?.link);
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPartnerCategoryData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchPartnerCategoryData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Irrigation Partner" }]} />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="form-add-h">Irrigation Partners</div>
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[1.75rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search irrigation partner..."}
            />
          </div>
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="">Add Irrigation Partners</span>
            </button>
          </div>
        </div>

        <div className="mt-[1.75rem]">
          <div className=" flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
            {processedData &&
              processedData?.map((item) => (
                <div
                  onClick={() => handleClick(item)}
                  key={item?.key}
                  style={{
                    borderRadius: "0.75rem",
                    background: "#F7F7F7",
                  }}
                  className="p-[1.25rem] border border-[#D6E1F5] lg:w-[280px] w-full cursor-pointer"
                >
                  <div className="flex justify-between">
                    <Tooltip
                      title={
                        shouldShowTooltip(item?.title)
                          ? formatText(item?.title)
                          : null
                      }
                    >
                      <div className="dash-card-h1 !text-[#424242] truncate">
                        {shouldShowTooltip(item?.title)
                          ? getShortText(item?.title)
                          : formatText(item?.title)}
                      </div>
                    </Tooltip>

                    <img src={item?.svg} alt={item?.svg} />
                  </div>

                  <div className="dash-card-h1 !text-[1.5rem] !font-[500] !text-[#050505] flex items-center  mt-[1rem]">
                    {item?.total}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <IrrigationPartnerAddModal
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchPartnerCategoryData}
      />
    </div>
  );
}

export default IrrigationPartnerTable;
